import { v4 as uuidv4 } from 'uuid';
import { BasePhotoDownloadView } from './BasePhotoDownloadView';

export const BasePhotoDownloadTab = (): ITab => {

    return {
        id: uuidv4(),
        title: 'Загрузка базовой картинки',
        view: {
            content: <BasePhotoDownloadView />
        }
    }
}